<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="query">
        <span>行政区划：</span>
        <div>
          <!-- <el-select
            v-model="town.adcdCode"
            placeholder="请选择行政区划"
            @change="adcdchange(town.adcdCode)"
            clearable
            filterable
          >
            <el-option
              v-for="item in town"
              :key="item.adcdCode"
              :label="item.adcdName"
              :value="item.adcdCode"
            ></el-option>
          </el-select> -->
           <el-cascader
            clearable
            v-model="townAdcdCode"
            :options="town"
            :props="{
              label: 'adcdName',
              value: 'adcdCode',
              expandTrigger: 'hover',
            }"
            @change="adcdchange"
          ></el-cascader>
        </div>
        <span>预警类型：</span>
        <div>
          <el-select
            v-model="thewarning"
            placeholder="请选择预警类型"
            @change="warntypechange"
            filterable
            label
          >
            <el-option
              v-for="item in warningtype"
              :key="item.warncode"
              :label="item.name"
              :value="item.warncode"
            ></el-option>
          </el-select>
        </div>
        <div class="queryBtn" @click="saveconfig">
          <div class="saveIcon"></div>
          <span>保存配置</span>
        </div>
        <div class="queryBtn" @click="onebtnconfig">
          <!-- <div class="saveIcon"></div> -->
          <span>一键配置</span>
        </div>
      </div>
      <div class="responselist" ref="responselist">
        <div>
          <el-col :span="11">
            <div ref="tableQuery" class="tableQuery">
              <span class="peopleList">责任人列表</span>
              <div class="department" >
                <span>部门/群组：</span>
                <div>
                  <el-cascader
                  ref="tree"
                  :key="deptAndGroupValue.deptId"
                   v-model="deptAndGroupValue"
                  :options="deptAndGroupData"
                   clearable
                  :show-all-levels="false"
                  placeholder="请选择部门/群组"
                  :props="{ expandTrigger: 'hover',value:'DeptId',label:'DeptName'}"
                  @change="getVal(deptAndGroupValue),Global.emptyQueryObj(deptAndGroupValue,searchresname)"></el-cascader>
                  <!-- <el-select
                    v-model="department"
                    placeholder="请选择部门"
                    filterable
                    clearable
                    @change="Global.emptyQuery(department,searchresname)"
                  >
                    <el-option
                      v-for="item in deptData"
                      :key="item.deptId"
                      :label="item.deptName"
                      :value="item.deptId"
                    ></el-option>
                </el-select> -->
                 <!-- <el-select v-model="deptAndGroupValue"
                  filterable
                  clearable
                  @change="Global.emptyQueryObj(deptAndGroupValue,searchresname)" value-key="deptId" placeholder="请选择部门/群组">
                  <el-option-group
                    v-for="group in deptAndGroupData"
                    :key="group.deptName"
                    :label="group.deptName">
                    <el-option
                      v-for="item in group.options"
                      :key="item.deptId"
                      :label="item.deptName"
                      :value="item"
                     >
                    </el-option>
                  </el-option-group>
              </el-select> -->
              </div>
             </div>
             <div class="street" >
                <span>乡镇：</span>
                <div>
                  <el-select
                    v-model="street"
                    placeholder="请选择乡镇"
                    filterable
                    clearable
                    @change="Global.emptyQuery(street,searchresname)"
                  >
                    <el-option
                      v-for="item in strData"
                      :key="item.adcd"
                      :label="item.adnm"
                      :value="item.adcd"
                    ></el-option>
                </el-select>
              </div>
             </div>
              <div class="search">
                <el-input v-model="searchname" placeholder="请输入责任人姓名"></el-input>
                <el-button @click="searchresname" type="primary" icon="el-icon-search">搜索</el-button>
              </div>
            </div>
            <el-table
              :data="data1"
              v-loading="zrrloading"
              :max-height="listHeight"
              border
              stripe
              ref="multipleTable"
              @row-click="clickRow"
              @selection-change="checkAll"
              style="width: 100%"
            >
              <el-table-column type="selection" min-width="30" :selectable="checkSelectable" align="center"></el-table-column>
              <el-table-column prop="personName" label="姓名" min-width="50"></el-table-column>
              <el-table-column prop="personPhone" label="手机" min-width="80"></el-table-column>
              <el-table-column prop="personPosition" label="岗位/职务" min-width="80"></el-table-column>
              <el-table-column prop="adcdName" label="部门/行政区划" min-width="80"></el-table-column>
            </el-table>
            <div ref="pager" class="pager">
              <pager
                @current-change="onCurrentChange"
                @size-change="onSizeChange"
                :pageIndex="pageIndex"
                :pageSize="pageSize"
                :total="total"
              ></pager>
            </div>
          </el-col>
          <el-col :span="2">
            <div class="opSetting">
              <div @click="handelSelect">
                <el-button
                  icon="el-icon-d-arrow-right"
                  :disabled="nowSelectData.length?false:true"
                  :size="buttonSize"
                  type="primary"
                >选中</el-button>
              </div>
              <div class="spacing" @click="handleRemoveSelect">
                <el-button
                  icon="el-icon-d-arrow-left"
                  :disabled="nowSelectRightData.length?false:true"
                  :size="buttonSize"
                  type="primary"
                >取消</el-button>
              </div>
            </div>
          </el-col>
          <el-col :span="11">
            <div class="tableQuery">
              <span>已选择责任人</span>
            </div>
            <el-table
              :data="selectArr"
              :max-height="listHeight"
              v-loading="loadingSelect"
              stripe
              border
              ref="multipleTable1"
              @row-click="clickRow1"
              @selection-change="checkRightAll"
              style="width: 100%"
            >
              <el-table-column type="selection" min-width="30" align="center"></el-table-column>
              <el-table-column prop="personName" label="姓名" min-width="50"></el-table-column>
              <el-table-column prop="personPhone" label="手机" min-width="80"></el-table-column>
              <el-table-column prop="personPosition" label="岗位/职务" min-width="80"></el-table-column>
              <el-table-column prop="adcdName" label="部门/行政区划" min-width="80"></el-table-column>
            </el-table>
          </el-col>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import warnTypes from '@/store/types/warningcenter'
import Pager from '@/components/Pager'
import adcdApi from '@/api/warningcenter'
export default {
  name: 'warnstaffing',
  components: {
    Pager
  },
  data () {
    return {
      zrrloading: false,
      loadingSelect: false,
      warningtype: [
        { name: '新生产预警', warncode: 'XCSYJ' },
        { name: '内部预警', warncode: 'NBYJ' },
        { name: '外部预警', warncode: 'WBYJ' },
        { name: '响应启动', warncode: 'XYQD' }
      ],
      thewarning: '新生产预警',
      searchname: '',
      department: '', // 部门
      deptData: [],
      street: '', // 街道
      strData: [],
      IsTown: '',
      town: [],
      town2: [],
      listHeight: 10,
      selectArr: [], // 右边列表
      buttonSize: 'large',
      options: [],
      value: '',
      data1: [],
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      adcdList: [{ AdcdCode: '0', AdcdLevel: '5' }],
      code: '',
      yjlx: 'XCSYJ',
      personId: '',
      resheight: '',
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      townAdcdCode: [],
      groupData: [],
      deptAndGroupData: [{ AdcdLevel: '', DeptId: '', DeptName: '部门', children: [] }, { AdcdLevel: '', DeptId: '', DeptName: '群组', children: [] }], // 部门群组合并数据
      deptAndGroupValue: [],
      deptAndGroupTree: {}
    }
  },
  computed: {},
  methods: {
    // 获取级联选择器元素
    getVal () {
      let tree = this.$refs.tree.getCheckedNodes()
      this.deptAndGroupTree = tree.length !== 0 ? tree[0].data : {}
    },
    onCurrentChange (page) {
      this.pageIndex = page
      this.personlist()
    },
    onSizeChange (size) {
      this.pageIndex = 1
      this.pageSize = size
      this.personlist()
    },
    //  行选中-左
    clickRow (row) {
      if (!row.disabled) {
        this.$refs.multipleTable.toggleRowSelection(row)
      }
    },
    //  行选中-右
    clickRow1 (row) {
      this.$refs.multipleTable1.toggleRowSelection(row)
    },
    // 自然村列表
    villagedata () {
      // this.$store.dispatch(warnTypes.GET_NATURAL_VILLAGE_LIST).then(data => {
      //   this.town = data
      // })
      let _this = this
      adcdApi.getNaturalVillageTree().then(res => {
        _this.town = Object.assign([], res.data ? res.data : [])
      })
    },
    // 获取部门列表
    deptChange () {
      this.$store.dispatch(warnTypes.GET_DEPTLIST).then(data => {
        this.deptData = data
        this.deptAndGroupData[0].children = this.deptData
      })
    },
    // 获取群组列表
    getGroups () {
      this.$store.dispatch(warnTypes.GET_GROUPLIST).then(data => {
        this.groupData = data
        let newGroupArr = []
        this.groupData.forEach(obj => {
          newGroupArr.push({ 'DeptId': obj.groupId, 'DeptName': obj.groupName, 'AdcdLevel': obj.adcdLevel })
        })
        this.deptAndGroupData[1].children = newGroupArr
      })
    },
    // 获取乡镇区划列表
    strChange () {
      this.$store.dispatch(warnTypes.GET_BASE_STREET_LIST, {
        IsTown: true,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      })
        .then(data => {
          this.strData = data.results
        })
    },
    // 群组配置列表
    configdata () {
      if (this.code === 'undefined' || this.code === '') {
      } else {
        this.loadingSelect = true
        this.$store
          .dispatch(warnTypes.GET_CONFIGURED_LIST, {
            adcdCode: this.code,
            yJLX: this.yjlx
          })
          .then(data => {
            this.loadingSelect = false
            this.selectArr = data
          })
      }
    },
    // 保存配置
    saveconfig () {
      if (this.townAdcdCode && this.townAdcdCode.length === 0) {
        this.$notify({
          title: '保存失败',
          message: '请选择行政区划',
          type: 'info'
        })
        return
      }
      this.selectArr.forEach(item => {
        if (this.personId === '') {
          this.personId += item.personId + ','
          this.personId = this.personId.substring(
            0,
            this.personId.lastIndexOf(',')
          )
        } else {
          this.personId += ',' + item.personId
        }
      })
      this.$store
        .dispatch(warnTypes.SAVE_CONFIGURED_INFO, {
          AdcdCode: this.code,
          YJLX: this.yjlx,
          PersonId: this.personId
        })
        .then(data => {
          if (data.result === 'Success') {
            this.$notify({
              title: '保存成功',
              message: '您已成功保存配置',
              type: 'success'
            })
          } else {
            this.$notify.error({
              duration: '2000',
              title: '保存失败',
              message: '请重新添加人员配置'
            })
          }
        })
    },
    // 一键配置
    onebtnconfig () {
      if (this.yjlx === 'XCSYJ') {
        this.thewarning = '新产生预警'
      } else if (this.yjlx === 'WBYJ') {
        this.thewarning = '外部预警'
      } else if (this.yjlx === 'NBYJ') {
        this.thewarning = '内部预警'
      } else if (this.yjlx === 'XYQD') {
        this.thewarning = '响应启动'
      }
      this.$confirm('确定要一键配置吗?', '确认').then(() => {
        this.$store.dispatch(warnTypes.ONE_CLICK_CONFIGURATION, {
          WarnType: this.thewarning
        }).then(data => {
          if (data.isSuccess) {
            this.$notify({
              title: '保存成功',
              message: '一键配置成功',
              type: 'success'
            })
          } else {
            this.$notify.error({
              duration: '2000',
              title: '保存失败',
              message: '一键配置失败'
            })
          }
        })
      }).catch(() => {})
    },
    warntypechange (val) {
      this.yjlx = val
      this.configdata()
    },
    adcdchange (adcdcode) {
      // if (adcdcode !== '' && adcdcode !== undefined) {
      //   this.code = adcdcode
      //   this.configdata()
      // }
      let _this = this
      if (adcdcode && adcdcode.length > 0) {
        _this.code = adcdcode[adcdcode.length - 1]
        _this.configdata()
      } else {
        _this.selectArr = []
      }
    },
    checkAll (val) {
      this.nowSelectData = val
    },
    checkRightAll (val) {
      this.nowSelectRightData = val
    },
    personlist () {
      this.zrrloading = true
      // 判断查询的是部门还是群组
      if (this.deptAndGroupTree.AdcdLevel === '5') { // 群组查询
        this.department = ''
        this.adcdList = [{ AdcdCode: this.deptAndGroupTree.DeptId, AdcdLevel: '5' }]
      } else if (!this.deptAndGroupTree || this.deptAndGroupTree.AdcdLevel === '' || this.deptAndGroupTree.AdcdLevel === undefined) { // 为空时，群组和部门全部查询
        this.department = ''
        this.adcdList = [{ AdcdCode: '0', AdcdLevel: '5' }]
      } else { // 部门查询
        this.department = this.deptAndGroupTree.DeptId ? this.deptAndGroupTree.DeptId : ''
        if (this.deptAndGroupTree.DeptId) {
          this.adcdList = [{ AdcdCode: '0', AdcdLevel: '5' }]
        }
      }
      this.$store
        .dispatch(warnTypes.GET_PERSONLIST, {
          personName: this.searchname,
          adcdList: this.adcdList,
          deptId: this.department,
          adcdCode: this.street,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        })
        .then(data => {
          this.data1 = data.results
          this.total = data.total
          this.zrrloading = false
        })
    },
    // 搜索
    searchresname () {
      this.pageIndex = 1
      this.personlist()
    },
    checkSelectable (row) {
      let obj = this.selectArr.find(item => {
        if (item.personId === row.personId) {
          row.disabled = true
          return item
        }
      })
      return !obj
    },
    // 选中
    handelSelect () {
      this.selectArr = this.handleConcatArr(this.selectArr, this.nowSelectData)
      this.$refs.multipleTable.clearSelection()
      this.nowSelectData = []
    },
    // 取消
    handleRemoveSelect () {
      this.data1.forEach(item => {
        this.nowSelectRightData.forEach(item1 => {
          if (item.personId === item1.personId) {
            item.disabled = false
          }
        })
      })
      this.handleRemoveTabList(this.nowSelectRightData, this.selectArr)
      this.nowSelectRightData = []
    },
    handleConcatArr (selectArr, nowSelectData) {
      let arr = []
      arr = arr.concat(selectArr, nowSelectData)
      return arr
    },
    handleRemoveTabList (isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i]['personId'] === originalArr[k]['personId']) {
              originalArr.splice(k, 1)
            }
          }
        }
      }
    }
  },
  mounted () {
    this.adcdchange()
    // 自然村列表
    this.villagedata()
    // 部门列表
    this.deptChange()
    // 乡镇列表
    this.strChange()
    // 群组列表
    this.getGroups()
    this.personlist()
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let queryDiv = document.getElementsByClassName('query')
      this.$refs['responselist'].style.height =
        contentDiv[0].offsetHeight - queryDiv[0].offsetHeight - 45 + 'px'
      let tableQueryXy = this.$refs.tableQuery.getBoundingClientRect()
      let pagerXy = this.$refs.pager.getBoundingClientRect()
      this.listHeight =
        document.documentElement.clientHeight -
        tableQueryXy.y -
        tableQueryXy.height -
        pagerXy.height -
        35
    })
  }
}
</script>
<style lang="less" src="@/assets/warningcenter.less" scoped></style>
<style lang="less" scoped>
body {
  background-color: #f0f2f6;
  margin: 0;
  padding: 0 0 10px 0;
}
.content {
  .query {
    height: 62px;
    background-color: #fff;
    font-size: 16px;
    padding-left: 10px;
    padding-right: 10px;
    > span {
      line-height: 62px;
      float: left;
    }
    > div {
      float: left;
      margin-right: 10px;
      line-height: 62px;
    }
    .imgIcon {
      width: 18px;
      height: 17px;
      background-image: url("~@/assets/monitorimg/add.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      // background-position: 0 5px;
      margin-top: 5px;
    }
    .queryBtn {
      color: #fff;
      padding: 9px 8px;
      cursor: pointer;
      border-radius: 3px;
      height: 45px;
      float: right;
      margin-top: 10px;
      background-color: #3e81fc;
      &:hover {
        background-color: #4d8cff;
      }
      .saveIcon {
        margin-right: 10px;
        .imgIcon();
        background-image: url("~@/assets/monitorimg/save.png");
      }
      > div,
      > span {
        float: left;
      }
      > span {
        line-height: 27px;
        text-align: center;
      }
    }
  }
  .adcdlist {
    float: left;
    width: 370px;
    height: 770px;
    padding: 15px 35px;
    background: #fff;
  }
  .responselist {
    padding-top: 15px;
    padding-bottom: 15px;
    width: 100%;
    background: #fff;
    overflow: hidden;
    margin-top: 15px;
    > div {
      margin-left: 1%;
      width: 98%;
      .el-table {
        margin-top: 5px;
      }
      .opSetting {
        text-align: center;
        margin-top: 100px;
      }
      .spacing {
        margin-top: 10px;
      }
    }
    .tableQuery {
      height: 45px;
      overflow: hidden;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      span {
        // float: left;
        line-height: 45px;
        width: calc(100% - 150px);
      }
      span.peopleList {
        width: 3.875rem;
      }
     div.department {
        div {
          width: calc(100% - 10px);
        }
        span {
        line-height: 45px;
        width: calc(100% - 120px);
      }
      }
       div.street {
        div {
          width: calc(100% - 10px);
        }
      }
      div.search {
        .el-input {
          width: calc(100% - 100px);
        }
        .el-button {
          margin-left: 5px;
          height: 40px;
        }
      }
    }
  }
}
.selcountry {
  width: 400px;
  margin-left: 10px;
  float: left;
}
.pager {
  overflow: hidden;
}
// 新增搜索条件样式
.department,.street,.search {
  display: flex;
}
</style>
